export const TENANT_ID = 'reference'; // NEW APP TODO: Replace with the appropriate tenant.
export const APP_ID = 'archetype-web'; // NEW APP TODO: Replace with appropriate Client ID.

export const MASONRY = {
  ROOT_NODE_ID_HOME_PAGE: 'demoHomePage$root', // NEW APP TODO: Replace tenant specific node id. This is a demo home masonry container.
};
